import { Directive, Input, HostListener, ElementRef } from '@angular/core'
import { Keys } from '@swimlane/ngx-datatable/release/utils';
import { AppDatatableEventsUtils } from './events.utils';

@Directive({
    selector: "[app-datatable-events-cell-bubble]"
})

export class AppDatatableEventsCellBubble {

    private _navtiveElement: any;

    private _cellElement: any;

    private _previousSibling: any;

    private _nextSibling: any;

    constructor (private elementRef: ElementRef) { //, @Host() @Optional() private tbl: AppDatatableComponent<any>) {//@Inject(forwardRef(() => AppDatatableComponent)) private datatable: AppDatatableComponent<any>) { 
        this._navtiveElement = elementRef.nativeElement;
    }

    @HostListener('blur', ['$event']) onBlur($event) {
        //console.log(">>AppDatatableEventsCellBubble blur", $event);
        if (this._setOrHasCellElement()) {
            let parentBlur = new FocusEvent("blur", { bubbles: true });
            this._cellElement.dispatchEvent(parentBlur);
        }
    }

    @HostListener('focus', ['$event']) onFocur($event) {
        //console.log(">>AppDatatableEventsCellBubble focus", $event);
        if (this._setOrHasCellElement()) {
            let parentFocus = new FocusEvent("focus", { bubbles: true });
            this._cellElement.dispatchEvent(parentFocus);
        }
    }

    @HostListener('keydown', ['$event']) onKeydown($event) {
        let inputElEvent = <KeyboardEvent>$event;
        if (inputElEvent.keyCode == Keys.up || inputElEvent.keyCode == Keys.down) {
            event.preventDefault();
            //this._navtiveElement.blur();
            // create blur on parent or sibling element as needed
            if(inputElEvent.keyCode == Keys.up && this._previousSibling) {
                this._previousSibling.focus();
            } else if(inputElEvent.keyCode == Keys.down && this._nextSibling) {
                this._nextSibling.focus();
            } else if (typeof (this._navtiveElement.blur) === 'function') {
                //keycode and which are readonly in typescript interface
                let keydownEvent: KeyboardEvent;
                keydownEvent = new KeyboardEvent("keydown", { key: inputElEvent.key, code: inputElEvent.code });
                Object.defineProperty(keydownEvent, 'keyCode', {
                    get: function () {
                        if (this.key === "ArrowUp") return Keys.up;
                        else if (this.key === "ArrowDown") return Keys.down;
                        else return 0;
                    }
                });
                Object.defineProperty(keydownEvent, 'which', {
                    get: function () {
                        if (this.key === "ArrowUp") return Keys.up;
                        else if (this.key === "ArrowDown") return Keys.down;
                        else return 0;
                    }
                });
                if (this._setOrHasCellElement()) {
                    let parentBlur = new FocusEvent("blur", { bubbles: true });
                    this._cellElement.dispatchEvent(parentBlur);
                    this._cellElement.dispatchEvent(keydownEvent);
                }
            }
        }
    }

    private _setOrHasCellElement(): boolean {
        if(this._cellElement) {
            return true;
        }

        let cellElement = AppDatatableEventsUtils.findParentCellElement(this._navtiveElement);
        if(cellElement) {
            this._cellElement = cellElement;
            this._setPreviousNextSibling();
            return true;
        }
        return false;
    }

    private _setPreviousNextSibling(): void {
        let siblings = AppDatatableEventsUtils.findPreviousNextInputSibling(this._navtiveElement, this._cellElement);
        if(siblings && siblings.previousSibling) {
            this._previousSibling = siblings.previousSibling;
        } 
        if(siblings && siblings.nextSibling) {
            this._nextSibling = siblings.nextSibling;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/datatable/directives/events-cell-bubble.ts